module.exports = __webpack_public_path__ + "static/media/argentina.d4f55b42.svg";